import Vue from 'vue';
import VueCookie from 'vue-cookie';

Vue.use(VueCookie);

export const PERSISTENCE_KEY = `adapi:key@${document.location.port}`;
const PERSISTENDE_DURATION = '30D'; // 30 days

export function save(key, remember = false) {
  if (!key) {
    return Vue.cookie.delete(PERSISTENCE_KEY);
  }

  return Vue.cookie.set(PERSISTENCE_KEY, key, remember ? { expires: PERSISTENDE_DURATION } : {});
}

export function load() {
  return Vue.cookie.get(PERSISTENCE_KEY) || null;
}



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/utils/apikey-persistance.js